// @flow
type GridItemData =
  | {
      type: 'board',
      images?: { [size: string]: Array<{ url: string }> },
      has_custom_cover?: boolean,
      cover_images?: { [size: string]: { url: string } },
    }
  | {
      type: 'pin' | 'interest',
      images?: { [size: string]: { url: string } },
    };

// Keep in sync with sizes and board data structure BoardCollage.js
// TODO (michelle): Import these consts from shared file
const NUM_BOARD_COLLAGE_IMAGES = 6;
const BOARD_COVER_SIZE_KEY = '222x';
const BOARD_THUMB_SIZE_KEY = '170x';

const pinImageSize = ({
  devicePixelRatio,
  isRetina,
}: {
  devicePixelRatio: number,
  isRetina: boolean,
}): string => {
  // `devicePixelRatio` maps to the image being loaded by the `srcset` directive in the image element.
  switch (devicePixelRatio) {
    case 1:
      return '236x';
    case 2:
      return '474x';
    case 3:
      return '736x';
    case 4:
      return 'orig';
    default:
      // `devicePixelRatio` is not available, fall back to using `isRetina` which is not trustworthy.
      return isRetina ? '474x' : '236x';
  }
};

const getGridItemImageUrls = ({
  item,
  devicePixelRatio,
  isRetina,
}: {
  item: GridItemData,
  devicePixelRatio: number,
  isRetina: boolean,
}): Array<string> => {
  switch (item.type) {
    // First, get the URL of the image that's actually being loaded.
    case 'pin':
    case 'interest': {
      const { images } = item;
      if (!images) {
        return [];
      }
      const size = item.type === 'interest' ? '400x' : pinImageSize({ devicePixelRatio, isRetina });
      const { url } = images[size] || {};
      return url ? [url] : [];
    }
    case 'board': {
      const { images, has_custom_cover: hasCustomCover, cover_images: coverImages } = item;
      if (!images) {
        return [];
      }
      const { url } = (hasCustomCover && coverImages && coverImages[BOARD_COVER_SIZE_KEY]) || {};
      // Only register for the first 6 images for each board, other images
      // won't be part of the board collage. When a custom cover is chosen for
      // a board, it'll only have 3 images in the board rep. It's ok that we still
      // register 6 images since we later check if the image element is in the
      // viewport
      return [
        ...(url ? [url] : []),
        ...(images[BOARD_THUMB_SIZE_KEY] || [])
          .slice(0, NUM_BOARD_COLLAGE_IMAGES)
          .map((image) => image.url)
          .filter(Boolean),
      ];
    }
    default:
  }
  return [];
};

export default getGridItemImageUrls;
